import { Component, ErrorBoundary, JSX } from "solid-js";
import { useAppRefresh } from "@/contexts/app-refresh/app-refresh.context";
import GlobalErrorModal from "../modals/global-error-modal/GlobalErrorModal";
import { MODAL_EXIT_DELAY_MS } from "@/shared/constants/event.const";

interface GlobalErrorCatcherProps {
  children: JSX.Element;
  onExit: () => void;
}

const ErrorFallback: Component<{
  error: Error;
  reset: () => void;
  children: JSX.Element;
  onExit: () => void;
}> = (props) => {
  const { refreshApp } = useAppRefresh();

  const handleRefresh = () => {
    refreshApp();
    setTimeout(() => props.reset(), 0); // Reset function to clear the error boundary state
  };

  const handleExit = () => {
    setTimeout(() => {
      props.onExit();
    }, MODAL_EXIT_DELAY_MS);
  };

  return (
    <>
      <div>{props.children}</div>
      <GlobalErrorModal onRefresh={handleRefresh} onExit={handleExit} />
    </>
  );
};

export const GlobalErrorCatcher: Component<GlobalErrorCatcherProps> = (
  props,
) => {
  return (
    <ErrorBoundary
      fallback={(error, reset) => (
        <ErrorFallback error={error} reset={reset} onExit={props.onExit}>
          {props.children}
        </ErrorFallback>
      )}
    >
      {props.children}
    </ErrorBoundary>
  );
};
